import { settings } from "nprogress";
import { store } from "./store";

export const paths = {
  index: '/',
  auth: {
    auth0: {
      callback: '/auth/auth0/callback',
      login: '/auth/auth0/login'
    },
    jwt: {
      login: '/auth/jwt/login',
      register: '/auth/jwt/register'
    },
    firebase: {
      login: '/auth/firebase/login',
      register: '/auth/firebase/register'
    },
    amplify: {
      confirmRegister: '/auth/amplify/confirm-register',
      forgotPassword: '/auth/amplify/forgot-password',
      login: '/auth/amplify/login',
      register: '/auth/amplify/register',
      resetPassword: '/auth/amplify/reset-password'
    }
  },
  authDemo: {
    forgotPassword: {
      classic: '/auth-demo/forgot-password/classic',
      modern: '/auth-demo/forgot-password/modern'
    },
    login: {
      classic: '/auth-demo/login/classic',
      modern: '/auth-demo/login/modern'
    },
    register: {
      classic: '/auth-demo/register/classic',
      modern: '/auth-demo/register/modern'
    },
    resetPassword: {
      classic: '/auth-demo/reset-password/classic',
      modern: '/auth-demo/reset-password/modern'
    },
    verifyCode: {
      classic: '/auth-demo/verify-code/classic',
      modern: '/auth-demo/verify-code/modern'
    }
  },

  dashboard: {
    index: '/dashboard',
    account: '/dashboard/account',
    user: {
      userList: '/dashboard/user',
      createUser: '/dashboard/user/createUser',
    },

    country: {
      index: '/dashboard/country',
      createCountry: '/dashboard/country/createCountry'
    },
   
  },

  //restaurants
  questionBank: {
    index: '/questionBank',
    question: {
      questionList: '/questionBank/question',
      createQuestion: '/questionBank/question/createQuestion',
    },
  },

  components: {
    index: '/components',
    lists: {
      groupedLists: '/components/lists/grouped-lists',
      gridLists: '/components/lists/grid-lists'
    },
    forms: '/components/forms',
  },
  notAuthorized: '/401',
  notFound: '/404',
  serverError: '/500'
};
